import { Link } from 'react-router-dom';
import { FacebookIcon } from '../images/facebook-icon';
import { TwitterIcon } from '../images/twitter-icon';
import { InstagramIcon } from '../images/instagram-icon';
import { YoutubeIcon } from '../images/youtube-icon';
import { LinkedInIcon } from '../images/linkedin-icon';
import { WeiboIcon } from '../images/weibo-icon';
import { WeChatIcon } from '../images/wechat-icon';
import { AthenaSwanIcon } from '../images/athena-swan-icon';
import { CurtinAllyIcon } from '../images/curtin-ally-icon';
import { AustralianTechnologyNetworkIcon } from '../images/australian-technology-network-icon';
import { EdxIcon } from '../images/edx-icon';
import { TikTokIcon } from '../images/tiktok-icon';
export default function Footer() {
  return (
    <footer className="bg-black text-sm font-normal leading-relaxed text-white">
      <div className="px-10">
        {/* Main Footer Navigation */}
        <div className="mb-10 grid w-full grid-cols-1 gap-x-8 gap-y-8 py-[3.2rem] text-sm font-bold leading-[21px] text-white lg:grid-cols-2 lg:text-base lg:leading-normal">
          {/* Campuses */}
          <div className="grid grid-cols-[1fr_2fr] pt-5">
            <h2 className="mb-4 text-lg leading-normal after:mt-4 after:block after:h-1.5 after:w-10 after:rounded-lg after:bg-curtin-footer-hover-lime after:content-['']">
              Campuses
            </h2>
            <div className="grid grid-cols-2 gap-x-6 gap-y-4">
              <Link
                to="https://about.curtin.edu.au/campus-locations/"
                className="underline hover:text-curtin-footer-hover-lime"
              >
                Australia
              </Link>
              <Link
                to="https://www.curtin.edu.my"
                className="text-sm underline hover:text-curtin-footer-hover-lime sm:text-base"
              >
                Malaysia
              </Link>

              <Link
                to="https://www.curtincolombo.lk/"
                className="text-sm underline hover:text-curtin-footer-hover-lime sm:text-base"
              >
                Colombo
              </Link>
              <Link
                to="http://curtinmauritius.ac.mu"
                className="text-sm underline hover:text-curtin-footer-hover-lime sm:text-base"
              >
                Mauritius
              </Link>
              <Link
                to="https://curtindubai.ac.ae"
                className="text-sm underline hover:text-curtin-footer-hover-lime sm:text-base"
              >
                Dubai
              </Link>
              <Link
                to="https://curtin.edu.sg"
                className="text-sm underline hover:text-curtin-footer-hover-lime sm:text-base"
              >
                Singapore
              </Link>
            </div>
          </div>

          {/* Teaching areas */}
          <div className="grid grid-cols-[1fr_2fr] pt-5">
            <h2 className="mb-4 text-lg leading-normal after:mt-4 after:block after:h-1.5 after:w-10 after:rounded-lg after:bg-curtin-footer-hover-lime after:content-['']">
              Teaching areas
            </h2>
            <div className="grid grid-cols-2 gap-x-6 gap-y-4">
              <Link to="https://karda.curtin.edu.au" className="underline hover:text-curtin-footer-hover-lime">
                Centre for Aboriginal Studies
              </Link>
              <Link
                to="https://www.curtin.edu.au/about/learning-teaching/humanities/"
                className="underline hover:text-curtin-footer-hover-lime"
              >
                Humanities
              </Link>
              <Link
                to="https://www.curtin.edu.au/about/learning-teaching/business-and-law/"
                className="underline hover:text-curtin-footer-hover-lime"
              >
                Business and Law
              </Link>
              <Link
                to="https://www.curtin.edu.au/about/learning-teaching/science-engineering/"
                className="underline hover:text-curtin-footer-hover-lime"
              >
                Science and Engineering
              </Link>
              <Link
                to="https://www.curtin.edu.au/about/learning-teaching/health-sciences/"
                className="underline hover:text-curtin-footer-hover-lime"
              >
                Health Sciences
              </Link>
            </div>
          </div>
        </div>

        {/* Social Media Links */}
        <div className="my-2 grid grid-cols-1 border-b-2 border-t-2 border-solid border-neutral-700 py-2 lg:grid-cols-2">
          <div className="item-center flex flex-wrap justify-start gap-6 py-8 sm:gap-10">
            <Link to="https://www.facebook.com/curtinuniversity" aria-label="Facebook" title="Facebook">
              <FacebookIcon />
            </Link>
            <Link to="https://twitter.com/curtinuni" aria-label="Twitter" title="Twitter">
              <TwitterIcon />
            </Link>
            <Link to="https://www.instagram.com/curtinuniversity/" aria-label="Instagram" title="Instagram">
              <InstagramIcon />
            </Link>
            <Link
              to="https://www.youtube.com/user/CurtinUniversity?sub_confirmation=1"
              aria-label="YouTube"
              title="YouTube"
            >
              <YoutubeIcon />
            </Link>
            <Link to="https://www.linkedin.com/school/8788/" aria-label="LinkedIn" title="LinkedIn">
              <LinkedInIcon />
            </Link>
            {/* Placeholder images for Weibo and WeChat */}
            <Link to="https://www.weibo.com/CurtinWestAustralia" aria-label="Weibo" title="Weibo">
              <WeiboIcon />
            </Link>
            <Link to="https://curtin.edu.au" aria-label="WeChat" title="WeChat">
              <WeChatIcon />
            </Link>
            <Link to="https://www.tiktok.com/@curtinuniversity?lang=en" aria-label="WeChat" title="TikTok">
              <TikTokIcon />
            </Link>
          </div>
          {/* Accreditation Logos */}

          <div className="flex flex-wrap items-center justify-between gap-4 sm:gap-6">
            <Link
              to="https://about.curtin.edu.au/learning-teaching/empowering-people/athena-swan/"
              aria-label="Athena Swan"
            >
              <AthenaSwanIcon />
            </Link>
            <Link to="https://students.curtin.edu.au/personal-support/lgbtiq/support/" aria-label="Curtin Ally">
              <CurtinAllyIcon />
            </Link>
            <Link to="https//www.atn.edu.au/" aria-label="Australian Technology Network">
              <AustralianTechnologyNetworkIcon />
            </Link>
            <Link to="https://www.edx.org/school/curtinx/" aria-label="Edx Member">
              <EdxIcon />
            </Link>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="grid grid-cols-1 gap-6 py-5 pr-10 lg:grid-cols-[1.6fr_1.4fr]">
          {/* copyright */}
          <div className="lg:order-0 order-1 flex flex-col text-white">
            <div className="flex flex-wrap gap-4">
              <Link
                to="https://www.curtin.edu.au/copyright-statement/"
                className="underline hover:text-curtin-footer-hover-lime"
              >
                Copyright
              </Link>
              <Link to="https://curtin.edu.au/disclaimer/" className="underline hover:text-curtin-footer-hover-lime">
                Disclaimer
              </Link>
              <Link
                to="https://curtin.edu.au/about/governance/privacy/"
                className="underline hover:text-curtin-footer-hover-lime"
              >
                Privacy
              </Link>
              <Link
                to="https://curtin.edu.au/home/ugc-statement/"
                className="underline hover:text-curtin-footer-hover-lime"
              >
                UGC Statement
              </Link>
              <Link
                to="https://www.curtin.edu.au/popular-links/#popular-courses/"
                className="underline hover:text-curtin-footer-hover-lime"
              >
                Popular Courses
              </Link>

              <Link to="https://curtin.edu.au/accessibility/" className="underline hover:text-curtin-footer-hover-lime">
                Accessibility
              </Link>
              <Link
                to="https://www.curtin.edu.au/about/contact/"
                className="underline hover:text-curtin-footer-hover-lime"
              >
                Contact
              </Link>
            </div>

            <div className="col-span-full py-10 text-xs text-curtin-footer-white">
              <p className="flex gap-8">
                <span>ABN 99 143 842 569.</span>
                <span>CRICOS Provider Code 00301J.</span>
                <span>
                  TEQSA{' '}
                  <span>
                    <Link
                      to="https://www.teqsa.gov.au/national-register/provider/curtin-university-formerly-curtin-university-technology"
                      className="bold text-white underline hover:text-curtin-footer-hover-lime"
                    >
                      {' '}
                      PRV12158
                    </Link>
                  </span>
                </span>
              </p>
            </div>
          </div>

          <div className="order-0 text-sm font-normal leading-relaxed text-curtin-footer-white sm:text-base lg:order-1">
            <p>
              Curtin University acknowledges all First Nations of this place we call Australia and recognises the many
              nations who have looked after Country for more than 60,000 years. We are honoured and grateful for the
              privilege to maintain campuses operating in Boorloo (Perth) and Karlkurla (Kalgoorlie) in Australia. We
              pay our respects to Elders past and present as Custodians and Owners of these lands. We recognise their
              deep knowledge and their cultural, spiritual and educational practices, and aspire to learn and teach in
              partnership with them. Curtin also acknowledges First Nations peoples connected with our global campuses.
              We are committed to working in partnership with all Custodians and Owners to strengthen and embed First
              Nations’ voices and perspectives in our decision-making, now and into the future.{' '}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
